import { PermissionsUserForm } from '../components'

export const PermissionsUserFormPage = () => {
  return <PermissionsUserForm />
}
